import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Requests a dropdown-owned scenario list refresh when the overlay opens.
 *
 * Scenario creation starts a background process, so the new scenario is often
 * not available when the mutation returns. Opening the dropdown is a natural
 * point to re-check the app's scenario list, but this must not dispatch
 * `me.get`: updating `me` wakes root context selectors and can make app
 * entity collections reload for a simple dropdown interaction.
 */
export const refreshScenariosOnOverlayDisplay = store.effects.create(
  (feature: Feature) =>
    feature.actions.displayOverlay.observe().pipe(
      rxjs.map(action =>
        feature.actions.refreshScenarios.request
          .from(action)
          .create(),
      ),
    ),
)
